export * from '@taqueria/protocol/out/types/Timestamp';
